import React from "react";

function Footer() {
  return (
    <footer className="bg-dark text-white text-center py-3">
      <p className="mb-0">
        &copy; 2025 UTAR Facial Recognition Attendance System. All rights reserved.
      </p>
    </footer>
  );
}

export default Footer;